import React from 'react';
import { connect } from 'react-redux';
import { List, Button, Box, Collapse } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { createActions } from '../../../store';
import { MAX_PARTICLES } from '../../../CreatePageConstants';
import CollapsibleSwitchListItem from '../../../../../list-items/CollapsibleSwitchListItem';
import ParticleElementListItem from './ParticleElementListItem';
import ParticlesDirectionListItem from './inputs/ParticlesDirectionListItem';
import ParticlesSpeedShiftListItem from './inputs/ParticlesSpeedShiftListItem';
import ParticlesFlockListItem from './inputs/ParticlesFlockListItem';
import ParticleImageCropperDialog from './inputs/ParticleImageCropperDialog';
import { PARTICLE_DIRECTIONS } from '../../../Preview/PreviewDisplayConstants';

const ParticlesListItem = (props) => {
    const { particleItemsLength, enabled, direction, addParticleElement, removeParticleElement, duplicateParticleElement, updateParticleElement, updateElementsSettings, advanced } = props;
    const indexes = Array.from({length: particleItemsLength}, (_, i) => i);

    const handleRemoveParticle = (index) => {
        removeParticleElement(index);
    };
    
    const onEnabledChange = (value) => {
        if (value) {
            updateElementsSettings({ particles: { enabled: true } });
            if (particleItemsLength === 0) {
                addParticleElement();
            }
        } else {
            updateElementsSettings({ particles: { enabled: false } });
        }
    };

    const renderContent = () => (
        <>
            <List
                dense
                disablePadding
            >
                <ParticlesDirectionListItem />
                <Collapse in={direction === PARTICLE_DIRECTIONS.FLOCK} timeout='auto' unmountOnExit>
                    <ParticlesFlockListItem />
                </Collapse>
                <ParticlesSpeedShiftListItem />
            </List>
            
            {/* Individual particle elements */}
            <List
                dense
                disablePadding
            >
                {indexes.map((index) =>
                    <ParticleElementListItem
                        key={index}
                        index={index}
                        particleItemsLength={particleItemsLength}
                        remove={() => handleRemoveParticle(index)}
                        duplicate={particleItemsLength < MAX_PARTICLES ? () => duplicateParticleElement(index) : null}
                    />
                )}
            </List>
            
            {advanced && (
                <>
                    <br/>
                    <Button 
                        startIcon={<AddIcon />} 
                        size='small'
                        disabled={particleItemsLength >= MAX_PARTICLES}
                        onClick={() => addParticleElement()}
                        sx={{ marginBottom: 1 }}
                    >
                        Add Particles
                    </Button>
                </>
            )}
            
            <ParticleImageCropperDialog />
        </>
    );

    return (
        <CollapsibleSwitchListItem
            checked={enabled}
            text='Particles'
            onChange={onEnabledChange}
            expansionEnabled={advanced}
        >
            {renderContent()}
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { items, enabled, direction } = state.createPreview.present.videoSettings.elements.particles;
    return {
        items,
        enabled,
        direction,
        particleItemsLength: items.length
    }
}

const mapDispatchToProps = (dispatch) => {
    const addParticleElement = () => dispatch(createActions.addParticleElement());
    const removeParticleElement = (index) => dispatch(createActions.removeParticleElement(index));
    const duplicateParticleElement = (index) => dispatch(createActions.duplicateParticleElement(index));
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    const updateElementsSettings = (properties) => dispatch(createActions.updateElementsSettings(properties));
    
    return { 
        addParticleElement,
        removeParticleElement,
        duplicateParticleElement,
        updateParticleElement,
        updateElementsSettings
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesListItem);